const clamp = function (_num, _min, _max) {
    return Math.min(Math.max(_num, _min), _max);
};

export default clamp;
